/**
 * Bundled provider logo URLs (webpack resolves these for dev + production).
 * Keep in sync with frontend/public/providers/*.svg for non-React consumers.
 */
import identityiqLogo from '../assets/providers/identityiq-logo.svg';
import smartcreditLogo from '../assets/providers/smartcredit-logo.svg';
import myscoreiqLogo from '../assets/providers/myscoreiq-logo.svg';
import myfreescorenowLogo from '../assets/providers/myfreescorenow-logo.svg';
import privacyguardLogo from '../assets/providers/privacyguard-logo.svg';
import creditHeroScoreLogo from '../assets/providers/credit-hero-score-logo.png';

export const PROVIDER_LOGO_ASSETS = {
  identityiq: identityiqLogo,
  smartcredit: smartcreditLogo,
  myscoreiq: myscoreiqLogo,
  myfreescorenow: myfreescorenowLogo,
  privacyguard: privacyguardLogo,
  credit_hero_score: creditHeroScoreLogo,
};

export const getBundledProviderLogoSrc = (providerKey) => {
  if (!providerKey) return null;
  const normalized = String(providerKey).toLowerCase().trim();
  return PROVIDER_LOGO_ASSETS[normalized] || null;
};
